import { useEffect, useRef, useState } from "react";

interface AlertWithProgressBarProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  progressColor: string;
  duration: number;
  type: 'success' | 'error' | 'info';
}


const GRADIENTS = {
  success: 'linear-gradient(90deg, #243E2D 17.31%, #282828 40.38%)',
  error: 'linear-gradient(90deg, #412727 17.31%, #282828 40.38%)',
  info: 'linear-gradient(90deg, #3B3728 17.31%, #282828 40.38%)',
};

const FADE_OUT = 1000; // ms

const AlertWithProgressBar: React.FC<AlertWithProgressBarProps> = (props) => {

  const { icon, title, description, progressColor, duration, type } = props;

  const barRef = useRef<HTMLDivElement>(null);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (barRef.current) {
        barRef.current.style.transform = 'scaleX(0)';
      }
    });
    const timeout = setTimeout(() => setFading(true), duration);
    return () => {
      clearTimeout(timeout);
    };
  }, [duration]);

  return (
    <div
      className="toast"
      style={{
        background: GRADIENTS[type],
        color: '#fff',
        borderRadius: 8,
        padding: '14px 16px',
        minWidth: 343,
        maxWidth: 400,
        width: '100%',
        boxShadow:
          '0 8px 10px 0 rgba(0,0,0,0.20), 0 6px 30px 0 rgba(0,0,0,0.12), 0 16px 24px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        alignItems: description ? 'flex-start' : 'center',
        gap: 16,
        position: 'relative',
        overflow: 'hidden',
        opacity: fading ? 0 : 1,
        transition: fading ? `opacity ${FADE_OUT}ms` : undefined,
      }}
    >
      {icon}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: description ? 'flex-start' : 'center',
        gap: description ? 2 : 0,
        height: '100%',
      }}>
        <div style={{
          fontWeight: 700,
          fontSize: 16,
          lineHeight: '18px',
          fontFamily: 'Nunito Sans, Nunito, Arial, sans-serif',
          color: '#FFFFFF',
          letterSpacing: 0,
          verticalAlign: 'middle',
        }}>{title}</div>
        {description && (
          <div style={{ fontSize: 14, color: '#D1D1D1' }}>{description}</div>
        )}
      </div>
      <div
        ref={barRef}
        style={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          height: 4,
          width: '100%',
          background: progressColor,
          transform: 'scaleX(1)',
          transformOrigin: 'left',
          transition: `transform ${duration}ms linear`,
          pointerEvents: 'none',
        }}
        className="toast-progress"
      />
    </div>
  );
};

export default AlertWithProgressBar;